import * as _ from 'lodash';
import moment from 'moment';

import { isNullOrEmpty } from '../../utilities/stringUtil.js';
import PrintUtility from '../../utilities/printUtility';
import {
  DATE_TIME_FORMAT,
  SORT_TYPE,
  UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED,
  SEARCH_CCUS_SENT_STATUS,
} from '../../utilities/constants';

/**
 * 作業員を割り当てられる現場ツリー情報取得API
 * @param {object}param:検索パラメーター
 * @return {object}searchParam:API通信用検索パラメーター
 * */
const createSearchFieldTreeWorkersParam = param => {
  const searchParam = Object.create(null);
  if (!isNullOrEmpty(param.workerId)) {
    searchParam.worker_id = param.workerId;
  }
  return searchParam;
};

/**
 * 不明な入退場データ検索パラメータ作成
 * @param {object}param:検索パラメーター
 * @return {object}searchParam:API通信用検索パラメーター
 * */
const createSearchUnidentifiedLogParam = param => {
  const searchParam = Object.create(null);
  searchParam.offset = param.offset;
  if (!isNullOrEmpty(param.order)) {
    if (param.sortType === SORT_TYPE.asc.id) {
      searchParam.order = param.order + SORT_TYPE.asc.name;
    } else {
      searchParam.order = param.order + SORT_TYPE.desc.name;
    }
  }
  searchParam.prior_ccus_error_flg = param.priorCcusError ? 1 : 0;
  if (!isNullOrEmpty(param.selectedSentStatus)) {
    // BLDE_V2-50500 【B-441の残対応】不明な入退場データ画面の送信状態に関する検索条件のUI変更
    // 送信状態に関する検索条件の表示項目を減らし、各項目に複数の送信状態を含めるように改善
    let selectedSentStatuses = [];
    switch (Number(param.selectedSentStatus)) {
      case UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED.EXEMPT.ID:
        // 対象外
        selectedSentStatuses = [SEARCH_CCUS_SENT_STATUS.exempt.id];
        break;
      case UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED.UNSENT.ID:
        // 未送信：変更未送信、送信中、変更送信中を含む
        selectedSentStatuses = [
          SEARCH_CCUS_SENT_STATUS.unsent.id,
          SEARCH_CCUS_SENT_STATUS.notSentAfterChange.id,
          SEARCH_CCUS_SENT_STATUS.sending.id,
          SEARCH_CCUS_SENT_STATUS.sendingAfterChange.id,
        ];
        break;

      case UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED.SENT.ID:
        // 送信済
        selectedSentStatuses = [SEARCH_CCUS_SENT_STATUS.sent.id];
        break;
      case UNREGISTERED_SEARCH_CCUS_SENT_STATUS_CONDENSED.SENDING_ERROR.ID:
        // 送信エラー
        selectedSentStatuses = [SEARCH_CCUS_SENT_STATUS.sendingError.id];
        break;
      default:
        break;
    }
    searchParam.ccus_send_status = selectedSentStatuses;
  }
  if (!isNullOrEmpty(param.fromDate)) {
    searchParam.record_date_from = param.fromDate;
  }
  if (!isNullOrEmpty(param.toDate)) {
    searchParam.record_date_to = param.toDate;
  }
  return searchParam;
};

/**
 * 作業員の現場割り当て追加用パラメータを作成
 * @param {object}reflectionFieldWorkerListParam:パラメーター
 * @param {object}reflectionUnidentifiedLogListParam:パラメーター
 * @return {object}updateParam:API通信用パラメーター
 * */
const createUpdateUnidentifiedLogParam = (
  reflectionFieldWorkerListParam,
  reflectionUnidentifiedLogListParam,
  reflectionFieldSpotWorkerParam
) => {
  const updateParam = Object.create(null);
  let unidentifiedLogList = [];
  reflectionFieldWorkerListParam.map(fieldWorker => {
    if (
      !isNullOrEmpty(
        _.find(reflectionUnidentifiedLogListParam, unidentifiedLog => {
          return unidentifiedLog.id === fieldWorker.id;
        })
      )
    ) {
      unidentifiedLogList.push({
        unidentified_logs_id: fieldWorker.id,
        field_tree_worker_id: fieldWorker.fieldTreeWorkerId,
      });
    }
  });
  reflectionFieldSpotWorkerParam.map(spotWorker => {
    if (
      !isNullOrEmpty(
        _.find(reflectionUnidentifiedLogListParam, unidentifiedLog => {
          return unidentifiedLog.id === spotWorker.id;
        })
      )
    ) {
      unidentifiedLogList.push({
        unidentified_logs_id: spotWorker.id,
        field_spot_worker_id: spotWorker.fieldSpotWorkerId,
      });
    }
  });
  updateParam.unidentified_logs = unidentifiedLogList;
  return updateParam;
};

const downloadCsv = (blob, fieldId) => {
  const csvBlob = new Blob([blob], { type: 'text/csv;charset=shift-jis;' });
  const filename = `不明な入退場データ_${fieldId}_${moment(new Date()).format(
    DATE_TIME_FORMAT.dateTimeSecondFormat
  )}.csv`;
  PrintUtility.printBlob(csvBlob, filename);
};

/**
 * 入退場実績画面で利用するビジネスロジック格納クラス
 * */
const InOutHistoryUserUnregisteredService = {
  createSearchFieldTreeWorkersParam,
  createSearchUnidentifiedLogParam,
  createUpdateUnidentifiedLogParam,
  downloadCsv,
};

export default InOutHistoryUserUnregisteredService;



// WEBPACK FOOTER //
// ./src/services/inOutHistoryUserUnregistered/InOutHistoryUserUnregisteredService.js